<template>
<div>
  <b-card>
    <grid-filters grid-data="theGrid" :fields="gridFilters" ></grid-filters>
    <div class="text-right mb-3">
      <exporter grid-ref="theGrid" :url="url + '/export'"></exporter>
    </div>
    <Grid ref="theGrid" name="inparResultsGrid" v-bind:url="url" v-bind:preload="preload" v-bind:columns="columns" :aggregate="aggregate"  :server-aggregates="true" :pageable='true' :filterable='true' :sortable='true' v-bind:schemaModelFields="schemaModelFields"></Grid>
  </b-card>
</div>
</template>

<script>
import Grid from '@/components/Grid.vue'
import router from '@/router'
import lists from '@/components/States.js'

export default {
  name: 'inparResultsGrid',
  components: {
    Grid
  },
  data() {
    return {
      gridFilters: [{
        field:'dealer_id',
        modal:'dealers-modal',
        foreign: 'id',
        placeholder: 'Distribuidor'
      }, {
        field:'dsr_id',
        modal:'dsr-modal',
        foreign: 'id',
        placeholder: 'DSR'
      }, {
        field:'prodaggreg_id',
        modal:'prodaggreg-modal',
        foreign: 'id',
        placeholder: 'Prodaggreg'
      }],
      schemaModelFields: {
        'created_at': {
          type: 'date'
        },
        'dsr_id': {
          type: 'number'
        },
        'total': {
          type: 'number'
        },
        'quantity': {
          type: 'number'
        },
        'quantity_total': {
          type: 'number'
        },
        'quantity_points': {
          type: 'number'
        },
        'operator': {
          type: 'number'
        },
        'operator_total': {
          type: 'number'
        },
        'operator_points': {
          type: 'number'
        }
      },
      aggregate: [{
        field: 'total',
        aggregate: "sum"
      }, {
        field: 'quantity',
        aggregate: "sum"
      }, {
        field: 'quantity_total',
        aggregate: "sum"
      }, {
        field: 'operator',
        aggregate: "sum"
      }, {
        field: 'operator_total',
        aggregate: "sum"
      }],
      preload: [{
        api: 'dsr/lst/dsr',
        field: 'dsr_id'
      }, {
        api: 'prodaggregs/lst',
        field: 'prodaggreg_id'
      }, {
        api: 'dealers/lst',
        field: 'dealer_id'
      }],
      url: 'inpar/results',
      columns: [{
        field: 'ym',
        title: 'Ano/Mês',
        width: '120px'
      },
      {
        field: 'prodaggreg_id',
        title: 'Prodaggreg',
        width: '220px'
      },
      {
        field: 'dealer_id',
        title: 'Distribuidor',
        width: '220px'
      },
      {
        field: 'dsr_id',
        title: 'DSR',
        width: '220px'
      },
      {
        field: 'total',
        title: 'Pontos Totais',
        width: '120px',
        aggregates: ["sum"],
        footerTemplate: "#=kendo.toString(sum, 'n0')#"
      },
      {
        field: 'quantity',
        title: 'Quantidade',
        width: '120px',
        aggregates: ["sum"],
        footerTemplate: "#=kendo.toString(sum, 'n0')#"
      },
      {
        field: 'quantity_points',
        title: 'Pts Quantidade',
        width: '120px'
      },
      {
        field: 'quantity_total',
        title: 'Total Quantidade',
        width: '120px',
        aggregates: ["sum"],
        footerTemplate: "#=kendo.toString(sum, 'n0')#"
      },
      {
        field: 'operator',
        title: 'Conquistas',
        width: '120px',
        aggregates: ["sum"],
        footerTemplate: "#=kendo.toString(sum, 'n0')#"
      },
      {
        field: 'operator_points',
        title: 'Pts Conquista',
        width: '120px'
      },
      {
        field: 'operator_total',
        title: 'Total Conquistas',
        width: '120px',
        aggregates: ["sum"],
        footerTemplate: "#=kendo.toString(sum, 'n0')#"
      },
      {
        field: 'created_at',
        title: 'Criado em',
        format: '{0:dd/MM/yyyy HH:mm}',
        type: 'date',
        width: '180px',
        filterable: {
          // ui: "datetimepicker"
          ui: function(element) {
            element.kendoDateTimePicker({
              format: 'dd/MM/yyyy HH:mm'
            })
          }
        }
      }]
    }
  },
  methods: {
    getBtnTemplate: function(item) {
      var route = router.resolve({
        name: 'inparResults.edit',
        params: {
          id: item.id
        }
      })
      if (this.$auth.check('inparResults.edit')) {
        return '<a href="' + route.href + '" class="btn btn-primary" ><i class="fa fa-pencil"></i> editar</a>'
      }
      return ''
    }
  }
}
</script>
